import React from "react";
import { SpinnerContainer, Spinner } from "./styles";
const SpinnerComponent = () => {
  return (
    <SpinnerContainer>
      <Spinner></Spinner>
    </SpinnerContainer>
  );
};
export default SpinnerComponent;
